import { create } from "zustand";
import { UserDto } from "@/Pages/Auth/types";
import { USER_PERMISSIONS } from "@/roles/types/enums";
import { UserSettingsDto } from "@/shared";

interface UserDataStore {
  userSettings: UserSettingsDto;
  userData: UserDto | null;
  setUserData: (details: UserDto | null) => void;
  setUserSettings: (userSettings: UserSettingsDto) => void;
}

export const useUserDataStore = create<UserDataStore>()(set => ({
  userData: null,
  setUserData: userData => set({ userData }),

  userSettings: {
    fileFormat: "",
    timeSettings: {
      dateFormat: null,
      timeZone: null
    }
  },
  setUserSettings: userSettings => set({ userSettings })
}));

export const getAccessStatus = (feature: USER_PERMISSIONS) =>
  Boolean(useUserDataStore.getState().userData?.permissions?.includes(feature));
